import { FiltroSolicitacaoOrcamentoModel } from "@/models/orcamento-auto-online/FiltroSolicitacaoOrcamentoModel";
import { orcamentoAutoApi } from "@/api/OrcamentoAutoApi";
import { FiltroOrcamentoSolicitadoDTO } from "@/api/orcamento-auto/FiltroOrcamentoSolicitadoDTO";
import Oficina from "@/models/orcamento-auto-online/Oficina";
import { VeiculoModel } from '@/models/orcamento-auto-online/VeiculoModel';
import { DadosComplementaresVeiculoDTO } from '@/api/orcamento-auto/DadosComplementaresVeiculoDTO';
import { AprovacaoSolicitacaoOrcamentoDTO } from '@/api/orcamento-auto/AprovacaoSolicitacaoOrcamentoDTO';
import { FaixaDePrecoDTO} from "@/models/orcamento-auto-online/FaixaPrecoConcerto";

class OrcamentoAutoOnlineService {
  pesquisar(filtro: FiltroSolicitacaoOrcamentoModel, options:any) {
    const filtroDTO: FiltroOrcamentoSolicitadoDTO = {
      status: filtro.status?.name,
      dataFim: filtro.dataFim,
      dataInicio: filtro.dataInicio,
      number: options?.page,
      size: options?.itemsLength,
      sort: "dataCriacao"
    };
   return orcamentoAutoApi.obterOrcamentos(filtroDTO);
  }

  obterOrcamentoPorID(id:number) {
    return orcamentoAutoApi.obterOcamentoPorId(id);
  }

  obterFotoPorIdOrcamentoENomeArquivo(idOrcamento:number, nomeArquivo:string) {
      return orcamentoAutoApi.obterFotoVeiculo(idOrcamento, nomeArquivo)
  }

  recusarOrcamento(idOrcamento:number, motivoRecusa?: string, realizarEstorno?: boolean) {
    return orcamentoAutoApi.recusar(idOrcamento, motivoRecusa, realizarEstorno);
  }

  atualizarInformacoesCadastrais(idOrcamento: number, detalhesOrcamento:any) {
    return orcamentoAutoApi.atualizarInformacoesCadastrais(idOrcamento, detalhesOrcamento);
  }

  obterOficinas(cidade:string, estado:string) {
    return orcamentoAutoApi.obterOficinas(cidade, estado);
  }

  obterOficinasComDistancia(cidade: string, estado: string, idCliente: number, idOrcamento: number) {
    return orcamentoAutoApi.obterOficinasComDistancia(cidade, estado, idCliente, idOrcamento);
  }

  aprovar(idOrcamento:number, veiculo: VeiculoModel, oficina:Oficina) {
    const aprovacaoSolicitacaoOrcamentoDTO: AprovacaoSolicitacaoOrcamentoDTO = {
      oficina: {
        cnpj: oficina?.CNPJ || "",
        email: oficina?.email || "",
        endereco: {
          bairro: oficina?.bairro || "",
          cep: oficina?.cep || "",
          cidade: oficina?.cidade || "",
          estado: oficina?.siglaEstado || "",
          logradouro: oficina?.endereco || "",
          numero: oficina?.enderecoNr || ""
        },
        nomeFantasia: oficina?.nomeFantasia || "",
        nomeResponsavel: oficina?.responsavel || "",
        razaoSocial: oficina?.razaoSocial || "",
        telefone: {
          ddd: oficina?.DDD || "",
          numero: oficina?.telefone || ""
        },
        tipo: oficina?.oficinaTipo || "",
        tipoCredenciamento: oficina?.oficinaCredenciamento || ""
      },
      quilometragem: veiculo.quilometragem || 0,
      tipoPintura: veiculo.tipoPintura?.name || "COMUM"
    }

   return orcamentoAutoApi.aprovar(idOrcamento, aprovacaoSolicitacaoOrcamentoDTO);
  }
  
  obterPDForcamento(idOrcamento:number) {
    return orcamentoAutoApi.obterPDForcamento(idOrcamento);
  }

  obterFaixaPrecoConcerto() {
    return orcamentoAutoApi.obterFaixaPrecoConcerto();
  }

  excluirFaixaPrecoConcerto(id:number) {
    return orcamentoAutoApi.excluirFaixaPrecoConcerto(id);
  }

  salvarFaixaPrecoConcerto(faixaDePrecoDTO:FaixaDePrecoDTO) {
    return orcamentoAutoApi.salvarFaixaPrecoConcerto(faixaDePrecoDTO);
  }

  obterClientesFrota() {
    return orcamentoAutoApi.obterClientesFrota();
  }

}

export const orcamentoAutoOnlineService = new OrcamentoAutoOnlineService();
